module.exports = __webpack_public_path__ + "media/applications/assets/images/materials/sweatshirt/4-2-149062266eafc102e1558b386656c588.jpg";